module.exports = __webpack_public_path__ + "static/assets/07a4037b7522de6475f507783dcf1b26.svg";